/**
 * POST /user/bulk-create — 게스트(ASSOCIATE) 일괄 등록 시 유효기간(일).
 * 서버 스펙: 등록 시점 기준 N일 (OpenAPI `validityDays`, 기본 30).
 */
export const BULK_CREATE_GUEST_VALIDITY_DAYS_DEFAULT = 30;
/** @deprecated 별칭 — `BULK_CREATE_GUEST_VALIDITY_DAYS_DEFAULT`와 동일 */
export const BULK_CREATE_GUEST_VALIDITY_DAYS = BULK_CREATE_GUEST_VALIDITY_DAYS_DEFAULT;

export const BULK_CREATE_GUEST_VALIDITY_DAYS_MIN = 1;
/** 관리 화면에서 허용하는 상한 (서버가 더 허용할 수 있음) */
export const BULK_CREATE_GUEST_VALIDITY_DAYS_MAX = 730;
